<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    size="1000_auto"
    class="edit-list-modal"
    :loading="loading"
    :confirm-loading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>编辑商品</span>
      <div class="to-view">
        <p
          @click="toView(item)"
          v-for="item in toList"
          :key="item.id"
          :class="{ active: item.id === active }"
        >
          <span class="circle"></span><span class="text">{{ item.text }}</span>
        </p>
        <span class="inline"></span>
      </div>
    </template>
    <template #content>
      <div class="own-content">
        <div>
          <div class="posaTop">
            <app-listing-header :listing="form" style="margin: 10px 0 0 10px"> </app-listing-header>
            <el-divider></el-divider>
          </div>
          <div class="pt136"></div>
          <!--      <el-tabs>-->
          <!--        <el-tab-pane label="运营信息">-->
          <el-row>
            <div>
              <el-form
                :model="form"
                ref="form"
                class="gj-form"
                label-position="right"
                label-width="100px"
              >
                <p class="from-title" id="good-price">商品调价</p>
                <el-row>
                  <el-col :span="9">
                    <el-form-item
                      prop="yourPrice"
                      label="原价"
                      :rules="[
                        { required: true, message: '请输入原价', trigger: 'blur' },
                        $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数'),
                      ]"
                    >
                      <gj-input
                        :width="inputWidth"
                        v-model="form.yourPrice"
                        :disabled="!$permission('listing:adjustSalePrice')"
                      >
                        <template slot="prepend">{{ form.currencySymbol }}</template>
                      </gj-input>
                      <gj-help class="gj-help" style="margin-left: 10px">
                        <div>Your Price</div>
                      </gj-help>
                    </el-form-item>
                  </el-col>
                  <el-col :span="9">
                    <el-form-item
                      label="优惠价"
                      prop="salePrice"
                      :rules="[$gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')]"
                    >
                      <gj-input
                        :width="inputWidth"
                        v-model="form.salePrice"
                        :disabled="!$permission('listing:adjustSalePrice')"
                      >
                        <template slot="prepend">{{ form.currencySymbol }}</template>
                      </gj-input>
                      <gj-help style="margin-left: 10px">
                        <div>Sale Price</div>
                      </gj-help>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item
                  label="优惠日期"
                  :rules="{
                    validator: validateSaleRangeDate,
                  }"
                  prop="saleRangeDate"
                >
                  <gj-date-picker
                    v-model="form.saleRangeDate"
                    :width="inputWidth"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :disabled="!$permission('listing:adjustSalePrice')"
                  ></gj-date-picker>
                  <gj-help style="margin-left: 10px">
                    <div>Sale Price</div>
                  </gj-help>
                </el-form-item>
                <div class="B2B-price">
                  <el-form-item
                    prop="businessPrice"
                    label="B2B售价"
                    :rules="[
                      $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数'),
                      {
                        validator: validateBusinessPrice,
                        trigger: 'blur',
                      },
                    ]"
                    class="B2B-price-item"
                  >
                    <gj-input
                      :width="inputWidth"
                      v-model="form.businessPrice"
                      placeholder="请输入B2B售价"
                      :disabled="!$permission('listing:adjustSalePrice')"
                    >
                      <template slot="prepend">{{ form.currencySymbol }}</template>
                    </gj-input>
                  </el-form-item>
                  <el-switch
                    class="switch-discount"
                    :disabled="!$permission('listing:adjustSalePrice')"
                    v-model="form.switchDiscount"
                  >
                  </el-switch>
                  <span class="B2B-price-message"> 是否添加数量折扣 </span>
                </div>
                <div v-if="form.switchDiscount" class="num-discount">
                  <el-form-item label="折扣方式">
                    <el-radio-group v-model="form.quantityType">
                      <el-radio label="percent" :disabled="!$permission('listing:adjustSalePrice')"
                        >商品价格折扣比例</el-radio
                      >
                      <el-radio label="fixed" :disabled="!$permission('listing:adjustSalePrice')"
                        >固定商品价格
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div v-if="form.quantityType" class="num-discount-inner">
                    <el-row class="discount-title">
                      <el-col :span="7"> 最小数量 </el-col>
                      <el-col :span="3">
                        {{ form.quantityType === 'percent' ? '折扣' : '商品售价' }}</el-col
                      >
                      <el-col :span="10">
                        <el-row type="flex" justify="center">
                          <el-col :span="10" v-if="form.quantityType === 'percent' && !form.isEu">
                            <p class="discount-p">商品售价</p>
                          </el-col>
                          <el-col :span="10" v-if="form.quantityType === 'percent' && form.isEu">
                            <p class="discount-p">含增值税（VAT）</p>
                          </el-col>
                          <el-col :span="10" v-if="form.isEu">
                            <p class="discount-p">不含增值税（VAT）</p></el-col
                          >
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-form-item
                      v-for="(item, index) of form.quantityPriceList"
                      :key="item.index"
                      :prop="'quantityPriceList.' + index + '.price'"
                      :rules="{
                        validator: validatePassQuantityPrice,
                        trigger: 'blur',
                      }"
                      label-width="0"
                      width="200px"
                      :class="[
                        'item-my',
                        index === form.quantityPriceList.length - 1 ? 'no-border-bottom' : '',
                      ]"
                    >
                      <el-row>
                        <el-col :span="7">
                          <gj-input
                            :disabled="!$permission('listing:adjustSalePrice')"
                            width="200px"
                            v-model="item.quantity"
                          >
                          </gj-input>
                        </el-col>
                        <el-col :span="3">
                          <gj-input
                            :disabled="!$permission('listing:adjustSalePrice')"
                            placeholder=""
                            width="90px"
                            v-model="item.price"
                            :clearable="false"
                          >
                            <template slot="append">
                              {{
                                form.quantityType === 'percent' ? '%' : form.currencySymbol
                              }}</template
                            >
                          </gj-input>
                        </el-col>
                        <el-col :span="10">
                          <el-row type="flex" justify="center">
                            <el-col :span="10" v-if="form.quantityType === 'percent' && !form.isEu">
                              <p class="discount-p">
                                {{ form.currencySymbol
                                }}{{
                                  (
                                    ((form.businessPrice ? form.businessPrice : form.yourPrice) *
                                      (100 - item.price)) /
                                    100
                                  ).toFixed(preciseNum)
                                }}
                              </p>
                            </el-col>
                            <el-col :span="10" v-if="form.isEu && form.quantityType !== 'percent'"
                              ><p class="discount-p">
                                {{ form.currencySymbol
                                }}{{
                                  (
                                    item.price /
                                    (1 + +form.sellVatRateMap[form.countryCode] / 100)
                                  ).toFixed(preciseNum)
                                }}
                              </p></el-col
                            >
                            <el-col :span="10" v-if="form.isEu && form.quantityType == 'percent'"
                              ><p class="discount-p">
                                {{ form.currencySymbol
                                }}{{
                                  (form.businessPrice
                                    ? (form.businessPrice * (100 - item.price)) / 100
                                    : (form.yourPrice * (100 - item.price)) / 100
                                  ).toFixed(preciseNum)
                                }}
                              </p></el-col
                            >
                            <el-col :span="10" v-if="form.isEu && form.quantityType === 'percent'"
                              ><p class="discount-p">
                                {{ form.currencySymbol
                                }}{{
                                  (
                                    ((form.businessPrice ? form.businessPrice : form.yourPrice) *
                                      (100 - item.price)) /
                                    100 /
                                    (1 + +form.sellVatRateMap[form.countryCode] / 100)
                                  ).toFixed(preciseNum)
                                }}
                              </p></el-col
                            >
                          </el-row>
                        </el-col>
                        <el-col :span="4" class="B2B-icon">
                          <i
                            class="el-icon-circle-plus-outline"
                            style="cursor: pointer"
                            @click="$addDiscount(index)"
                          ></i>
                          <i
                            class="el-icon-remove-outline"
                            style="cursor: pointer;margin-left:24px"
                            @click="$deleteDiscount(index)"
                          ></i>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </div>
                </div>
                <p class="from-title" id="list-info" style="margin-top: 24px">listing信息</p>
                <el-form-item
                  label="商品标题"
                  prop="title"
                  :rules="[{ required: true, message: '请输入商品标题', trigger: 'blur' }]"
                >
                  <gj-textarea
                    v-model="form.title"
                    style="width: 750px"
                    maxlength="500"
                    show-word-limit
                    :disabled="!$permission('listing:editListing')"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                  ></gj-textarea>
                </el-form-item>
                <el-form-item
                  label="商品图片"
                  :rules="{
                    required: true,
                    validator: validateImageParams,
                  }"
                  prop="imageParams"
                >
                  <ul class="img-contain">
                    <li v-for="(item, index) of form.imageParams" :key="index">
                      <div class="product-img">
                        <!-- <gj-image v-if="item.imageUrl" :src="item.imageUrl" :size="125"></gj-image> -->
                        <gj-upload
                          :disabled="!$permission('listing:editListing')"
                          :imageUrl.sync="item.imageUrl"
                          container-type="product"
                          type="image"
                          fileRoleType="public"
                          img-height="135px"
                          img-width="135px"
                        ></gj-upload>
                        <p class="img-title" style="color: #666666">
                          {{ variantMenu[item.variant] }}
                        </p>
                        <i
                          class="el-icon-delete own-el-icon-delete"
                          v-show="item.imageUrl"
                          @click="deleteImage(index, item)"
                        ></i>
                        <span v-show="item.imageUrl" class="modal-bag"></span>
                      </div>
                    </li>
                  </ul>
                </el-form-item>
                <p class="from-title" id="operating-information" style="margin-top: 8px">
                  运营信息
                </p>
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="负责人">
                      <gj-charger-select
                        v-model="form.chargeUserIds"
                        collapse-tags
                        placeholder="全部负责人"
                        :active="false"
                        style="width: 260px"
                        :disabled="!$permission('listing:editDuty')"
                      >
                      </gj-charger-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="运营状态">
                      <gj-operation-state-select
                        width="260px"
                        placeholder="运营状态"
                        v-model="form.operationStatus"
                        :disabled="!$permission('listing:editOperationInfo')"
                      >
                      </gj-operation-state-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <p class="from-title" id="fulfillment-id" style="margin-top: 8px">配送渠道</p>
                <el-form-item label="配送渠道" prop="fulfillment">
                  <el-radio-group v-model="form.fulfillment">
                    <el-radio
                      :disabled="!$permission('listing:editFulfillment')"
                      v-for="item in fulfillmentOptions"
                      :label="item.id"
                      :key="item.id"
                      >{{ item.text }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <div
                  style="margin-left: 100px; margin-bottom: 20px"
                  v-if="form.fulfillment === 'AFN'"
                >
                  <el-switch
                    v-model="form.switchFulfillment"
                    :disabled="!$permission('listing:editFulfillment')"
                  >
                  </el-switch
                  ><span style="padding-left: 10px"
                    >开启自动转换配送渠道；当FBA可售为0时，自动转换为FBM；当FBA可售大于0时，自动转换为FBA</span
                  >
                </div>
                <div>
                  <el-row v-if="form.switchFulfillment && form.fulfillment === 'AFN'">
                    <el-col :span="10">
                      <el-form-item
                        v-if="form.fulfillment === 'AFN'"
                        prop="mfnPrice"
                        label="FBM售价"
                        :rules="[{ required: true, message: '请输入FBM售价', trigger: 'blur' }]"
                      >
                        <gj-input
                          :disabled="!$permission('listing:editFulfillment')"
                          :width="inputWidth"
                          v-model="form.mfnPrice"
                          placeholder="请输入FBM售价"
                        >
                          <template slot="prepend">{{ form.currencySymbol }}</template>
                        </gj-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item
                        v-if="form.fulfillment === 'AFN'"
                        prop="afnPrice"
                        label="FBA售价"
                        :rules="[{ required: true, message: '请输入FBA售价', trigger: 'blur' }]"
                      >
                        <gj-input
                          :disabled="!$permission('listing:editFulfillment')"
                          :width="inputWidth"
                          v-model="form.afnPrice"
                          placeholder="请输入FBA售价"
                        >
                          <template slot="prepend">{{ form.currencySymbol }}</template>
                        </gj-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="
                      form.fulfillment === 'MFN' ||
                      (form.switchFulfillment && form.fulfillment === 'AFN')
                    "
                  >
                    <el-col :span="10">
                      <el-form-item
                        prop="mfnQuantity"
                        label="FBM库存数量"
                        :rules="[{ required: true, validator: validateMfnQuantity }]"
                      >
                        <gj-input
                          :disabled="!$permission('listing:editFulfillment')"
                          :width="inputWidth"
                          v-model="form.mfnQuantity"
                          placeholder="请输入FBM库存数量"
                        >
                        </gj-input>
                        <gj-help class="gj-help" style="margin-left: 10px">
                          <div>显示在亚马逊前台的FBM数量</div>
                        </gj-help>
                        <span v-if="form.mfnQuantity > form.availableQuantity"
                          >当前库存数量大于自营仓可用量，可能会出现无法配送的情况</span
                        >
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item prop="mfnFulfillmentLatency" label="FBM处理时间">
                        <gj-input
                          :disabled="!$permission('listing:editFulfillment')"
                          :width="inputWidth"
                          v-model="form.mfnFulfillmentLatency"
                          placeholder="请输入FBM处理时间"
                          :rules="[
                            { required: true, message: '请输入FBM处理时间', trigger: 'blur' },
                          ]"
                        >
                          <template slot="append">天</template>
                        </gj-input>
                        <gj-help class="gj-help" style="margin-left: 10px">
                          <div>Handing Time</div>
                        </gj-help>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </el-row>
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { formRuleMixin, modalMixIn } from '../../../../../minxins';
import {
  syncListingGoodsDetail,
  updateListingInfo,
  syncLSaveListingGoods,
} from '../../../../../api/sale';
import AppListingHeader from './listing-header';
import { convertToDate } from '@/utils/date.util';
import { isArray } from 'xe-utils';

const defefaultImageParams = [
  // 图片类型，MAIN：主图，PT01-PT08：副图，SWCH：标签图
  {
    imageUrl: '',
    variant: 'MAIN',
  },
  {
    imageUrl: '',
    variant: 'PT01',
  },
  {
    imageUrl: '',
    variant: 'PT02',
  },
  {
    imageUrl: '',
    variant: 'PT03',
  },
  {
    imageUrl: '',
    variant: 'PT04',
  },
  {
    imageUrl: '',
    variant: 'PT05',
  },
  {
    imageUrl: '',
    variant: 'PT06',
  },
  {
    imageUrl: '',
    variant: 'PT07',
  },

  {
    imageUrl: '',
    variant: 'PT08',
  },
  {
    imageUrl: '',
    variant: 'SWCH',
  },
];
export default {
  name: 'app-edit-listing-modal',
  components: { AppListingHeader },
  mixins: [modalMixIn, formRuleMixin],
  props: {
    id: {
      required: true,
    },
  },
  created() {
    this.getListing();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  data() {
    return {
      validateBusinessPrice: (rule, value, callback) => {
        if (+this.form.businessPrice > +this.form.yourPrice) {
          callback(new Error('B2B售价不得大于原价'));
        } else {
          callback();
        }
      },
      validateMfnQuantity: (rule, value, callback) => {
        if (!this.form.mfnQuantity) {
          callback(new Error('请输入FBM库存数量'));
        } else if (this.form.mfnQuantity > this.form.availableQuantity) {
          callback();
        } else {
          callback();
        }
      },
      validateImageParams: (rule, value, callback) => {
        if (this.form.imageParams[0].imageUrl) {
          callback();
        } else {
          callback(new Error('请至少上传主图'));
        }
      },
      validatePassQuantityPrice: (rule, value, callback) => {
        const index = rule.fullField.split('.')[1],
          quantityPrice = this.form.quantityPriceList[index];
        let flag = true;
        if (!(quantityPrice.quantity && quantityPrice.price)) {
          flag = false;
          callback(new Error('请输入数量和折扣值'));
        } else if (!this.RE.pt0.test(quantityPrice.quantity)) {
          flag = false;
          callback(new Error('数量必须为正整数'));
        } else if (
          this.form.quantityType === 'percent' &&
          (quantityPrice.price >= 100 || quantityPrice.price <= 0)
        ) {
          flag = false;
          callback(new Error('只能填0到100之间的数字，不包括0到100'));
        } else if (
          this.form.quantityType === 'percent' &&
          !/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,3})?$/.test(quantityPrice.price)
        ) {
          flag = false;
          callback(new Error('折扣值不得超过三位小数'));
        } else {
          for (let i = 0; i < this.form.quantityPriceList.length; i++) {
            if (
              i == index ||
              !this.form.quantityPriceList[i].quantity ||
              !this.form.quantityPriceList[i].price
            )
              continue;
            if (quantityPrice.quantity === this.form.quantityPriceList[i].quantity) {
              flag = false;
              callback(new Error('数量值不得相同'));
              break;
            }
            if (+quantityPrice.quantity > +this.form.quantityPriceList[i].quantity) {
              if (this.form.quantityType === 'percent') {
                if (+quantityPrice.price <= +this.form.quantityPriceList[i].price) {
                  flag = false;
                  callback(new Error('数量越多，折扣值越大'));
                  break;
                }
              } else {
                if (+quantityPrice.price >= +this.form.quantityPriceList[i].price) {
                  flag = false;
                  callback(new Error('数量越多，优惠价越低'));
                  break;
                }
              }
            }
          }
        }
        if (flag) callback();
      },
      validateSaleRangeDate: (rule, value, callback) => {
        if (
          this.form.salePrice &&
          (!Array.isArray(this.form.saleRangeDate) || this.form.saleRangeDate.length < 1)
        ) {
          callback(new Error('已填优惠价， 请输入优惠日期'));
        } else {
          callback();
        }
      },
      active: 'good-price',
      toList: [
        { text: '商品调价', id: 'good-price', top: 0 },
        { text: 'Listing信息', id: 'list-info', top: 170 },
        { text: '运营信息', id: 'operating-information', top: 399 },
        { text: '配送渠道', id: 'fulfillment-id', top: 400 },
      ],
      preciseNum: 2,
      fulfillmentOptions: [
        {
          id: 'AFN',
          text: '亚马逊配送（FBA）',
        },
        {
          id: 'MFN',
          text: '卖家自配送（FBM）',
        },
      ],
      variantMenu: {
        MAIN: '主图',
        PT01: '副图',
        PT02: '副图',
        PT03: '副图',
        PT04: '副图',
        PT05: '副图',
        PT06: '副图',
        PT07: '副图',
        PT08: '副图',
        SWCH: '标签图',
      },
      form: {
        quantityType: 'percent',
        saleRangeDate: [],
        imageParams: [],
        isNumDiscount: false,
        discountType: 0,
        quantityPriceList: [],
      },
      inputWidth: '230px',
      loading: false,
    };
  },
  methods: {
    handleScroll(e) {
      let scrollTop = e.target.scrollTop;
      if (scrollTop < 170) {
        this.active = 'good-price';
      } else if (scrollTop >= 170 && scrollTop < 399) {
        this.active = 'list-info';
      } else if (scrollTop >= 399) {
        this.active = 'operating-information';
      }
    },
    deleteImage(index, item) {
      item.imageUrl = '';
    },
    toView(item) {
      this.active = item.id;
      this.$nextTick(() => {
        // document.getElementById(id).scrollIntoView({
        //   block: 'start', // 上边框与视窗顶部平齐。默认值
        // });
        // behavior: "smooth", // 平滑过渡
        document.querySelector('.el-dialog__body').scrollTop = item.top;
      });
    },
    // 减少折扣维度
    $deleteDiscount(index) {
      if (this.form.quantityPriceList.length <= 1) {
        this.$gjMessage.warning('最少需留一条数据');
        return;
      }
      this.form.quantityPriceList.splice(index, 1);
    },
    // 新增折扣维度
    $addDiscount(index) {
      if (this.form.quantityPriceList.length >= 5) {
        this.$gjMessage.warning('最多只可添加5条');
        return;
      }
      this.form.quantityPriceList.splice(index + 1, 0, {
        quantity: '',
        price: '',
      });
    },
    // 初始化表单数据
    getListing() {
      this.loading = true;
      syncListingGoodsDetail(this.id)
        .then((data) => {
          this.form = {
            ...this.form,
            ...this._.cloneDeep(data),
            saleRangeDate: [
              data.saleStartDate ? data.saleStartDate : '',
              data.saleEndDate ? data.saleEndDate : '',
            ],
          };
          if (!Array.isArray(this.form.quantityPriceList)) {
            this.form.quantityPriceList = [
              {
                id: 0,
                quantity: '',
                price: '',
              },
              {
                id: 1,
                quantity: '',
                price: '',
              },
            ];
          }
          let mp = {};
          if (Array.isArray(data.imageParams)) {
            for (let { imageUrl, variant } of data.imageParams) {
              mp[variant] = imageUrl;
            }
          }
          this.form.imageParams = this._.cloneDeep(defefaultImageParams);
          for (let item of this.form.imageParams) {
            if (mp[item.variant]) {
              item.imageUrl = mp[item.variant];
            }
          }
          if (!this.form.quantityType) {
            this.form.quantityType = 'percent';
          }
        })
        .complete(() => (this.loading = false));
    },
    // 提交
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          if (Array.isArray(this.form.saleRangeDate) && this.form.saleRangeDate.length > 1) {
            this.form.saleStartDate = this.form.saleRangeDate[0];
            this.form.saleEndDate = this.form.saleRangeDate[1];
          }
          syncLSaveListingGoods({
            ...this.form,
            saleStartDate: convertToDate(this.form.saleStartDate),
            saleEndDate: convertToDate(this.form.saleEndDate),
            quantityPriceList: this.form.switchDiscount ? this.form.quantityPriceList : [],
          })
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('after');
            })
            .complete(() => (this.confirmLoading = false));
        }
      });
    },
  },
  beforeDestroy() {
    //离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.edit-list-modal {
  /deep/.el-radio__label {
    color: rgba(51, 51, 51, 1) !important;
  }
  /deep/ .el-divider {
    margin-top: 5px;
  }
  /deep/.el-dialog__body {
    padding: 0 !important;
  }
  /deep/.loading-container {
    height: 100%;
  }
  .own-content {
    height: 100%;
    overflow: auto;
    overflow: overlay;
    padding: 16px 20px;
  }
  .pt136 {
    padding-top: 109px;
  }
  .posaTop {
    position: absolute;
    top: 44px;
    width: 960px;
    background: #ffffff;
    z-index: 50;
  }
}
.product-img {
  position: relative;
  .own-el-icon-delete {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    color: white;
    z-index: 10;
    cursor: pointer;
  }
  /deep/ .el-upload {
    border: 1px solid #d9d9d9 !important;
  }
  .modal-bag {
    width: 138px;
    height: 140px;
    display: none;
    position: absolute;
    top: 0;
    background: rgba(51, 51, 51, 0.7);
  }
}
.product-img:hover .own-el-icon-delete {
  display: inline-block;
}
.product-img:hover .modal-bag {
  display: inline-block;
}

.to-view {
  font-weight: 400;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  .active {
    .circle {
      background: #1f6eef !important;
    }
    .text {
      color: #1f6eef !important;
      font-weight: 600;
    }
  }
  top: 230px;
  position: absolute;
  right: 15px;
  .circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d8dadd;
    margin-right: 10px;
    cursor: pointer;
  }
  p {
    position: relative;
    z-index: 2;
  }
  .text {
    cursor: pointer;
    color: #333333;
  }
  .inline {
    position: absolute;
    top: 25px;
    display: inline-block;
    height: 82px;
    width: 1px;
    z-index: 1;
    left: 4px;
    background: #d8dadd;
  }
}
.img-contain {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 750px;
  padding: 0;
  margin: 0;
  justify-content: space-between;
  list-style: none;
  li {
    width: 135px;
  }
}
.num-discount {
  margin-top: 10px;
  padding-left: 60px;
}
.num-discount-inner {
  width: 750px;
  margin-left: 40px;
  background: #ffffff;
  border: 1px solid #e4e5e6;
  box-sizing: border-box;
  border-radius: 2px;
}
.discount-title {
  font-weight: 600;
  color: #333333;
  padding: 10px 0px 10px 10px;
  background: #f6f8fb;
  border-radius: 2px 2px 0px 0px;
  border-bottom: 1px solid #e4e5e6;
}
.item-my {
  padding: 16px 0 16px 10px;
  border-bottom: 1px solid #e4e5e6;
  margin-bottom: 0;
  /deep/.el-row {
    border: none;
  }
}
.no-border-bottom {
  border-bottom: 0px solid #e4e5e6 !important;
}
.discount-p {
  text-align: left;
  margin: 0;
}
.from-title {
  height: 12px;
  line-height: 12px;
  font-weight: bold;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  padding-left: 6px;
  border-left: 4px solid #1f6eef;
  margin-bottom: 12px;
}
.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  display: none;
  cursor: pointer;
}
.setting-wrapper:hover .setting-icon {
  display: inline;
  line-height: 1;
}
.B2B-price {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.B2B-price-item {
  margin: 0;
}
.B2B-price-message {
  font-size: 12px;
  margin-left: 5px;
  white-space: nowrap;
}
.B2B-icon {
  font-size: 20px;
  text-align: center;
}
.switch-discount {
  margin-left: 8px;
}
.img-title {
  text-align: center;
  background: #f6f8fb;
  border-radius: 2px;
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
